module.exports = __webpack_public_path__ + "static/media/06.6962fa3f.png";